import CryptoJS from "crypto-js";

const secretKey = "";

const encrypt = (data) => {
  return CryptoJS.AES.encrypt(data, secretKey).toString();
};

const decrypt = (data) => {
  const bytes = CryptoJS.AES.decrypt(decodeURIComponent(data), secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};

const enctyptionHelper = {
  encrypt,
  decrypt,
};
export default enctyptionHelper;
